import * as React from 'react';
import * as Styled from './overview-game-card.styled';
interface OverviewGameCardProps {
  image: Edge.Image;
  gameIcon: Edge.Image;
  title: string;
  url: string;
  aboveTitleText: string;
}
export const OverviewGameCard = React.memo(function OverviewGameCard({
  image,
  gameIcon,
  title,
  aboveTitleText,
  url
}: OverviewGameCardProps) {
  return <Styled.Wrapper href={url}>
      <Styled.Image src={image.src} alt={image.alt || title} width={510} height={300} />
      <Styled.BottomContent>
        <Styled.GameIcon src={gameIcon.src} />
        <div>
          <Styled.AboveTitleText>{aboveTitleText}</Styled.AboveTitleText>
          <Styled.CardTitle>{title}</Styled.CardTitle>
        </div>
      </Styled.BottomContent>
    </Styled.Wrapper>;
});